export default __webpack_public_path__ + "static/media/gallery-wip-greeblies_19.d69616dc.jpg";